import React, { useState, useEffect } from 'react';

import { Card, CardHeader, Grid, Typography, CardContent, TextField, FormHelperText, Button, Dialog, DialogContent } from '@material-ui/core';
import Icon from '@mdi/react';
import { Autocomplete } from '@material-ui/lab';
import MapPosition from '../../../pages/centers/components/mapPosition';
import classes from '../../../pages/createOrder/index.module.scss'
import CommonRepository from 'client-sdk/src/Repository/common-repository';
import handleError from '../../../utils/handleError';
import { Controller } from 'react-hook-form';
import { mdiPlusCircle, mdiCheckCircle } from '@mdi/js';

const provinces = {
    VIP: [1, 31],
    VVIP: [1],
    courier_COD: [1, 31]
}

const validateNumber = (value) => {
    if (!value) {
        return true
    }

    const pattern = /^[0-9]+$/;
    return pattern.test(value)
}

function CustomerInfo(props: any) {
    const { fulfillmentService, cod, deliveryLocationType, disableAll, handleLocations, location } = props;
    const {
        errors,
        watch,
        setValue,
        getValues,
        register,
        control
    } = props.form
    const values = getValues();
    const [provincesList, setProvincesList] = useState([]);
    const [citiesList, setCitiesList] = useState([]);
    const [openMsg, setOpenMsg] = useState(false);
    const handleCloseModal = () => {
        setOpenMsg(false);
    }

    useEffect(() => {
        getProvinces()
    }, []);

    const getCities = async (provinceId: number) => {
        try {
            const response = await CommonRepository.getCities({ payload: { 'provinceId.equals': provinceId } });
            setCitiesList(response.data)
        } catch (err) {
            handleError(err)
        }
    };

    const getProvinces = async () => {
        try {
            const response = await CommonRepository.getProvinces({ payload: {} });
            setProvincesList(response.data)
        } catch (err) {
            handleError(err)
        }
    };

    const provinceList = () => {
        // if (values.deliveryType == "VIP" && !fulfillmentService) {
        //     return provincesList.filter((el: any) => {
        //         return provinces["VIP"].includes(el.id)
        //     })
        // }
        if (values.deliveryType == "VVIP") {
            return provincesList.filter((el: any) => {
                return provinces["VVIP"].includes(el.id)
            })
        }
        // if (values.deliveryType == "COURIER" && cod) {
        //     return provincesList.filter((el: any) => {
        //         return provinces["courier_COD"].includes(el.id)
        //     })
        // }
        if (values.deliveryType == "COURIER" && ["CHAPAR", "nedex"].includes(values.orderTplType)) {
            return provincesList.filter((el: any) => {
                return el.id !== 1
            })
        }
        return provincesList
    }

    return (
        <Card
            className={classes.card}
        >
            <CardContent style={{ padding: "12px !important" }}>
                <Grid container spacing={3}>
                    <Grid
                        container
                        item
                        xs={12}
                        sm={4}
                        md={4}
                        lg={4}
                        alignItems="flex-end"
                    >
                        <div className={classes.item}>
                            <div style={{ width: '100%' }}>
                                <Controller
                                    style={{ width: '100%' }}
                                    control={control}
                                    name="customerName"
                                    label="نام و نام خانوادگی"
                                    rules={{
                                        required: true,
                                    }}
                                    as={
                                        <TextField
                                            name="customerName"
                                            // label="نام و نام خانوادگی"
                                            type="search"
                                            variant="outlined"
                                            fullWidth
                                            id="customerName"
                                            disabled={values.deliveryType == "" || disableAll}
                                            error={
                                                !!errors.customerName && !!errors.customerName
                                            }
                                        />}
                                />
                                <FormHelperText error focused>
                                    {errors.customerName &&
                                        'نام گیرنده الزامی میباشد'}
                                </FormHelperText>
                            </div>
                        </div>
                    </Grid>
                    <Grid
                        container
                        item
                        xs={12}
                        sm={4}
                        md={4}
                        lg={4}
                        alignItems="flex-start"
                    >
                        <div className={classes.item}>
                            <div style={{ width: '100%' }}>
                                <Controller
                                    style={{ width: '100%' }}
                                    control={control}
                                    name="customerNationalCode"
                                    label="کد ملی (۱۰ رقمی)"
                                    rules={{
                                        required: false,
                                        validate: validateNumber
                                    }}
                                    as={
                                        <TextField
                                            type="search"
                                            variant="outlined"
                                            fullWidth
                                            id="customerNationalCode"
                                            disabled={values.deliveryType == "" || disableAll}
                                            inputRef={register({
                                                required:
                                                    false,
                                                minLength: 10,
                                                maxLength: 10,
                                                pattern: /[0-9]/
                                            })}
                                            error={
                                                !!errors.customerNationalCode &&
                                                !!errors.customerNationalCode
                                            }
                                        />
                                    }
                                />
                                <FormHelperText error focused>
                                    {errors.customerNationalCode?.type === 'required' &&
                                        'کد ملی سفارش دهنده الزامی میباشد'}
                                </FormHelperText>
                                <FormHelperText error focused>
                                    {(errors.customerNationalCode?.type ===
                                        'minLength' ||
                                        errors.customerNationalCode?.type ===
                                        'maxLength') &&
                                        'کد ملی 10 رقم میباشد'}
                                </FormHelperText>
                                <FormHelperText error focused>
                                    {errors.customerNationalCode?.type === 'validate' &&
                                        'لطفا عدد انگلیسی وارد کنید'}
                                </FormHelperText>
                            </div>
                        </div>
                    </Grid>
                    <Grid
                        container
                        item
                        xs={12}
                        sm={4}
                        md={4}
                        lg={4}
                        alignItems="flex-start"
                    >
                        <div className={classes.item}>
                            <div dir="rtl" style={{ width: '100%' }}>
                                <Controller
                                    style={{ width: '100%' }}
                                    control={control}
                                    name="customerMobileNumber"
                                    label=" شماره همراه (۰۹۱۲۳۴۵۶۷۸۹)"
                                    rules={{
                                        required: true,
                                    }}
                                    as={
                                        <TextField
                                            type="search"
                                            variant="outlined"
                                            fullWidth
                                            inputRef={register({
                                                required: true,
                                                minLength: 11,
                                                maxLength: 11,
                                                pattern: /[0-9]/
                                            })}
                                            id="customerMobileNumber"
                                            disabled={values.deliveryType == "" || disableAll}
                                            error={
                                                !!errors.customerMobileNumber &&
                                                !!errors.customerMobileNumber
                                            }
                                        />
                                    }
                                />
                                <FormHelperText error focused>
                                    {errors.customerMobileNumber?.type === 'required' &&
                                        'شماره‌همراه سفارش‌دهنده الزامی می باشد'}
                                </FormHelperText>
                                <FormHelperText error focused>
                                    {(errors.customerMobileNumber?.type ===
                                        'minLength' ||
                                        errors.customerMobileNumber?.type ===
                                        'maxLength') &&
                                        'شماره‌همراه سفارش‌دهنده 11 رقم می باشد'}
                                </FormHelperText>
                                <FormHelperText error focused>
                                    {errors.customerMobileNumber?.type === 'validate' &&
                                        'لطفا عدد انگلیسی وارد کنید'}
                                </FormHelperText>
                            </div>
                        </div>
                    </Grid>

                    {/* <Grid
                            container
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            lg={4}
                            alignItems="flex-start"
                        >
                            <div className={classes.item}>
                                <div dir="rtl" style={{ width: '100%' }}>
                                    <Controller
                                        style={{ width: '100%' }}
                                        control={control}
                                        name="customerPhoneNumber"
                                        label="شماره ثابت (۰۲۱۷۷۷۷۷۷۷۷)"
                                        rules={{
                                            required: false,
                                        }}
                                        as={
                                            <TextField
                                                type="search"
                                                variant="outlined"
                                                fullWidth
                                                id="customerPhoneNumber"
                                                disabled={values.deliveryType == "" || disableAll}
                                                inputRef={register({
                                                    required:
                                                        false,
                                                    pattern: /^(\+98|0)?\d{2,3}\d{8}$/
                                                    // minLength: 5
                                                })}
                                                error={
                                                    !!errors.customerPhoneNumber &&
                                                    !!errors.customerPhoneNumber
                                                }
                                            />
                                        }
                                    />
                                    <FormHelperText error focused>
                                        {errors.customerPhoneNumber?.type === 'required' &&
                                            'شماره ثابت سفارش‌ دهنده الزامی میباشد'}
                                    </FormHelperText>
                                    <FormHelperText error focused>
                                        {errors?.customerPhoneNumber?.type === 'pattern' &&
                                            'شماره ثابت سفارش دهنده 10 یا 11 رقم می باشد'}
                                    </FormHelperText>
                                </div>
                            </div>
                        </Grid> */}
                    <Grid
                        container
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={4}
                        alignItems="flex-start"
                    >
                        <div className={classes.item}>
                            <div style={{ width: '100%' }}>
                                <Controller
                                    name="customerProvince"
                                    control={control}
                                    defaultValue=""
                                    rules={{ required: true }}
                                    render={({ value }) => (
                                        <Autocomplete
                                            noOptionsText="موردی یافت نشد"
                                            getOptionSelected={(option, value) =>
                                                option.name === value?.name
                                            }
                                            getOptionLabel={option => option.name}
                                            options={provinceList()}
                                            inputValue={value}
                                            disabled={values.deliveryType == "" || disableAll || fulfillmentService || deliveryLocationType}
                                            onChange={(event: any, newValue: any) => {
                                                setValue("customerCity", "")
                                                getCities(newValue?.id)
                                                setValue("customerProvince", newValue?.name)
                                            }}
                                            renderInput={params => (
                                                <TextField
                                                    {...params}
                                                    label="استان"
                                                    variant="outlined"
                                                    onChange={(e) => setValue("customerProvince", e.target.value)}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <React.Fragment>
                                                                {params.InputProps.endAdornment}
                                                            </React.Fragment>
                                                        ),
                                                    }}
                                                />
                                            )}
                                        />
                                    )}
                                />
                                <FormHelperText error focused>
                                    {errors?.customerProvince &&
                                        'استان سفاش‌دهنده الزامی میباشد'}
                                </FormHelperText>
                            </div>
                        </div>
                    </Grid>
                    <Grid
                        container
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={4}
                        alignItems="flex-start"
                    >
                        <div className={classes.item}>
                            <div style={{ width: '100%' }}>
                                <Controller
                                    name="customerCity"
                                    control={control}
                                    defaultValue=""
                                    rules={{ required: true }}
                                    render={({ value }) => (
                                        <Autocomplete
                                            noOptionsText="موردی یافت نشد"
                                            getOptionSelected={(option, value) =>
                                                option.name === value?.name
                                            }
                                            getOptionLabel={option => option.name}
                                            options={citiesList}
                                            inputValue={value}
                                            disabled={values.deliveryType == "" || disableAll || fulfillmentService || deliveryLocationType}
                                            onChange={(event: any, newValue: any) => {
                                                setValue("customerCity", newValue?.name)
                                            }}
                                            renderInput={params => (
                                                <TextField
                                                    {...params}
                                                    label="شهر"
                                                    variant="outlined"
                                                    // inputRef={register({ required: true })}
                                                    // InputLabelProps={{ shrink: true }}
                                                    onChange={(e) => setValue("customerCity", e.target.value)}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <React.Fragment>
                                                                {params.InputProps.endAdornment}
                                                            </React.Fragment>
                                                        ),
                                                    }}
                                                />
                                            )}
                                        />
                                    )}
                                />
                                <FormHelperText error focused>
                                    {errors?.customerCity &&
                                        'شهر سفاش‌دهنده الزامی میباشد'}
                                </FormHelperText>
                            </div>
                        </div>
                    </Grid>
                    <Grid
                        container
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={4}
                        alignItems="flex-start"
                    >
                        <div className={classes.item}>
                            <div style={{ width: '100%' }}>
                                <Controller
                                    style={{ width: '100%' }}
                                    control={control}
                                    name="customerZipCode"
                                    label="کد پستی (۱۰ رقمی)"
                                    rules={{
                                        required: ["EXPRESS_POST", "TAPIN_POST", "TAPIN_KETAB"].includes(values.orderTplType),
                                        validate: validateNumber
                                    }}
                                    as={
                                        <TextField
                                            type="search"
                                            variant="outlined"
                                            fullWidth
                                            id="customerZipCode"
                                            inputRef={register({
                                                required: true,
                                                minLength: 10,
                                                maxLength: 10,
                                                pattern: /[0-9]/
                                            })}
                                            disabled={values.deliveryType == "" || disableAll}
                                            error={
                                                !!errors.customerZipCode &&
                                                !!errors.customerZipCode
                                            }
                                        />
                                    }
                                />
                                <FormHelperText error focused>
                                    {errors?.customerZipCode?.type === 'required' &&
                                        'کد پستی سفارش‌دهنده الزامی میباشد'}
                                </FormHelperText>
                                <FormHelperText error focused>
                                    {(errors.customerZipCode?.type === 'minLength' ||
                                        errors.customerZipCode?.type === 'maxLength') &&
                                        'کد پستی 10 رقم می باشد'}
                                </FormHelperText>
                                <FormHelperText error focused>
                                    {errors.customerZipCode?.type === 'validate' &&
                                        'لطفا عدد انگلیسی وارد کنید'}
                                </FormHelperText>
                            </div>
                        </div>
                    </Grid>
                    <Grid
                        container
                        item
                        xs={12}
                        sm={8}
                        md={8}
                        lg={8}
                        alignItems="flex-end"
                    >
                        <div className={classes.item}>
                            <div style={{ width: '100%' }}>
                                <Controller
                                    style={{ width: '100%' }}
                                    control={control}
                                    name="customerAddress"
                                    label="آدرس گیرنده"
                                    rules={{
                                        required: true,
                                    }}
                                    as={
                                        <TextField
                                            type="search"
                                            variant="outlined"
                                            label="آدرس گیرنده"
                                            fullWidth
                                            disabled={values.deliveryType == "" || deliveryLocationType || disableAll}
                                            id="customerAddress"
                                            name="customerAddress"
                                            // InputLabelProps={{
                                            //     shrink: true,
                                            // }}
                                            error={
                                                !!errors.customerAddress &&
                                                !!errors.customerAddress
                                            }
                                        />
                                    }
                                />
                                <FormHelperText error focused>
                                    {errors?.customerAddress &&
                                        'آدرس گیرنده الزامی میباشد'}
                                </FormHelperText>
                            </div>
                        </div>
                    </Grid>
                    <Grid
                        container
                        item
                        xs={12}
                        sm={4}
                        md={4}
                        lg={4}

                    >
                        <div className={classes.item}>

                            {

                                location?.lat === 0
                                    ?
                                    <Button
                                        variant="outlined"
                                        className={classes.addProductIcon}
                                        // color="primary"
                                        size="large"

                                        onClick={() => setOpenMsg(true)}
                                        data-cy="addProduct"
                                        style={{
                                            width: '100%', height: '56px',
                                            marginBottom: '2px', display: 'flex', justifyContent: 'space-between'
                                        }}
                                    >
                                        <span>{'اضافه کردن موقعیت مکانی'}</span>
                                        <Icon path={mdiPlusCircle} color="#25368C" size={1} />
                                    </Button>
                                    :
                                    <Button
                                        variant="outlined"
                                        className={classes.addProductIcon}
                                        // color="primary"
                                        onClick={() => setOpenMsg(true)}
                                        size="large"
                                        style={{
                                            width: '100%', height: '56px',
                                            marginBottom: '2px', display: 'flex', justifyContent: 'space-between'
                                        }}

                                        data-cy="addProduct"
                                    >
                                        <span>{'موقعیت شما با موفقیت ثبت شد'}</span>
                                        <span style={{ display: 'flex', alignItems: 'center', color: '#32CD32' }}>
                                            <Icon path={mdiCheckCircle} size={1} />
                                        </span>

                                    </Button>
                            }





                        </div>

                    </Grid>
                    <Grid container item xs={12} lg={12} alignItems="flex-end">
                        <div className={classes.item}>
                            <div style={{ width: '100%' }}>
                                <Controller
                                    style={{ width: '100%' }}
                                    control={control}
                                    name="description"
                                    label="توضیحات"
                                    rules={{
                                        required: false,
                                    }}
                                    as={
                                        <TextField
                                            label="توضیحات"
                                            type="search"
                                            variant="outlined"
                                            fullWidth
                                            id="description"
                                            name="description"
                                            disabled={values.deliveryType == "" || disableAll}
                                        />
                                    }
                                />
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </CardContent>
            <Dialog
                open={openMsg}
                onClose={handleCloseModal}
                aria-labelledby="responsive-dialog-title"
                maxWidth="sm"
                fullWidth
                style={{ padding: '16px' }}
            >
                <Grid container>
                    {/* <form > */}
                    <DialogContent style={{ paddingTop: '0' }}>
                        <Grid item md={12} lg={12} style={{ height: '440px' }}>
                            <div
                                style={{
                                    width: '100%',
                                    paddingTop: '64px',
                                    paddingBottom: '15px',
                                    borderBottom: '1px solid #cccccc'
                                }}
                            >
                                <MapPosition
                                    zoom={14}
                                    style={{
                                        width: '300',
                                        height: '300px',
                                        border: 'solid 2px gray',
                                        marginTop: '-40px',
                                        borderRadius: '4px',

                                    }}
                                    center={
                                        location?.lat !== 0
                                            ? location
                                            : {
                                                lat: 35.6892,
                                                lng: 51.389,
                                            }
                                    }
                                    position={location}
                                    setLatlng={(latLng: { lat: number; lng: number }) => {
                                        handleLocations(latLng)
                                    }}
                                />
                            </div>
                            <div style={{ margin: '25px 0', textAlign: 'center' }}>
                                <Button
                                    variant="contained"
                                    color='primary'
                                    onClick={handleCloseModal}
                                >
                                    {`تایید`}
                                </Button>
                            </div>



                        </Grid>
                    </DialogContent>
                    {/* </form> */}
                </Grid>
            </Dialog>
        </Card>
    )
}

export default CustomerInfo;